var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('search',{attrs:{"scope":"mine","context":false}}),_vm._v(" "),_c('result'),_vm._v(" "),_c('back-to-top')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }